export default "__VITE_ASSET__BjmkUvjd__"